<template>
  <div>
    <tables :config="config()" />
  </div>
</template>

<script>
  export default {
    props: {
      detail: {
        type: Object,
        default: {}
      }
    },
    data () {
      return {
        
      }
    },
    components: {
      tables: () => import(/* webpackPrefetch: true */ '@/components/basic/table.vue')
    },
    watch: {
      
    },
    computed: {
      
    },
    mounted () {
      
    },
    methods: {
      config () {
        return {
          // CONFIG PARSING API
          api: `admin/produk/${this.detail.layanan_kode}`,

          // SINGLE
          single: true,

          // CHECKBOX
          checkbox: true,

          // PADDING
          padding: 'py-0',

          // HEIGHT
          height: true,

          // CONFIG PARSING HEADER
          header: [
            {
              text: '#No',
              width: '75px',
              value: 'index',
              sortable: false,
              freeze: true,
              hide: false,
              align: 'center'
            },
            {
              text: 'No. Reg',
              width: '200px',
              value: 'prod_ajuan_no_reg',
              freeze: true,
              hide: false
            },
            {
              text: 'Kode Ajuan',
              width: '200px',
              value: 'prod_from_layanan_kode',
              freeze: false,
              hide: false,
              format: 'regex'
            },
            // {
            //   text: 'Kode Produk',
            //   width: '200px',
            //   value: 'prod_layanan_kode',
            //   freeze: false,
            //   hide: false,
            //   format: 'regex'
            // },
            {
              // text: 'Nomor (NIK/KK/DLL)',
              text: 'Nomor Kartu Keluarga',
              width: '200px',
              value: 'prod_nomor',
              freeze: false,
              hide: false
            },
            {
              text: 'Nama Identitas Produk',
              width: '200px',
              value: 'prod_nama',
              freeze: false,
              hide: false
            },
            {
              text: 'Status',
              width: '200px',
              value: 'prod_status',
              freeze: false,
              hide: false
            },
            {
              text: 'Tanggal',
              width: '200px',
              value: 'prod_create_datetime',
              freeze: false,
              hide: false,
              format: 'datetime'
            }
          ],

          // CONFIG PARSING FILTER
          filter: [
            {
              field: 'prod_ajuan_no_reg',
              label: 'No. Reg',
              type: 'text',
              placeholder: 'Contoh. KK-20220812000004',
              value: '',
              width: '55%',
              required: false
            },
            {
              field: 'prod_status',
              label: 'Status',
              type: 'select',
              placeholder: 'Contoh. DIAJUKAN TTE',
              value: '',
              option: ['BELUM DIVERIFIKASI', 'BELUM DIAJUKAN TTE', 'DIAJUKAN TTE', 'TIDAK DIPROSES', 'SIAP DIDOWNLOAD', 'SIAP DICETAK', 'SUDAH DICETAK', 'SIAP DIAMBIL', 'SUDAH DIAMBIL'],
              width: '60%',
              required: false
            },
            {
              field: 'prod_create_datetime',
              label: 'Tanggal',
              type: 'date',
              placeholder: 'Contoh. 2021-12-13',
              value: '',
              picker: false,
              width: '40%',
              required: false
            }
          ],

          // PREFIX KEY
          prefix: '',

          // CONFIG PARSING FORM
          form: [],

          // CONFIG PARSING ACTION
          action: {
            tab: {
              button: false,
              api: [],
              field: ''
            },
            filter: {
              button: true,
              api: ''
            },
            add: {
              button: false,
              api: '',
              window: false,
              href: ''
            },
            edit: {
              button: false,
              api: '',
              window: false,
              href: ''
            },
            delete: {
              button: false,
              api: ''
            },
            detail: {
              button: true,
              api: '/product/'
            },
            reject: {
              button: false,
              api: ''
            },
            approve: {
              button: false,
              api: ''
            },
            print: {
              button: false,
              api: ''
            },
            freeze: {
              button: true,
              api: ''
            },
            hide: {
              button: false,
              api: ''
            }
          }
        }
      }
    }
  }
</script>